"use client";

import React from "react";
import CtaBand from "@/components/common/CtaBand";
import { useLanguage } from "@/hooks/useLanguage";
import { pick } from "@/lib/i18n";
import { COMMON, type L6 } from "@/lib/commonCopy";
interface Copy {
  eyebrow: L6;
  heading: L6;
  lead: L6;
  secondaryLabel: L6;
}
const copyData: Copy = {
  eyebrow: {
    en: "Product Catalog & Engineering",
    zh: "产品目录与工程定制",
    es: "Catálogo de productos e ingeniería",
    de: "Produktkatalog & Engineering",
    fr: "Catalogue de produits et ingénierie",
    pt: "Catálogo de produtos e engenharia"
  },
  heading: {
    en: "Need Custom Wire Mesh Specifications or Volume Supply?",
    zh: "需要定制丝网规格或批量供货方案？",
    es: "¿Necesita especificaciones a medida o suministro por volumen?",
    de: "Benötigen Sie kundenspezifische Drahtgewebe-Spezifikationen?",
    fr: "Besoin de toiles métalliques sur mesure ou d'un volume industriel ?",
    pt: "Necessita de especificações sob medida ou fornecimento em volume?"
  },
  lead: {
    en: "Send your mesh count, wire diameter, micron rating, or fabrication drawings for technical verification and commercial proposals.",
    zh: "请提供目数、丝径、微米级过滤精度或图纸尺寸，我们将完成技术核算并出具详细商务报价。",
    es: "Comparta número de malla, diámetro de alambre, micraje o planos para verificación técnica y presupuesto comercial.",
    de: "Senden Sie Maschenweite, Drahtdurchmesser, Feinheit oder Zeichnungen für technische Prüfung und Preisangebote.",
    fr: "Indiquez numéro de mesh, diamètre de fil, seuil micronique ou plans pour validation technique et devis commercial.",
    pt: "Envie contagem de malha, diâmetro de fio, micragem ou desenhos para verificação técnica e proposta comercial."
  },
  secondaryLabel: {
    en: "Contact Engineering",
    zh: "联系工程团队",
    es: "Contactar ingeniería",
    de: "Engineering kontaktieren",
    fr: "Contacter l'ingénierie",
    pt: "Fale com a engenharia"
  }
};
export default function QuoteCTA() {
  const {
    lang
  } = useLanguage();
  return <CtaBand id="quotecta" eyebrow={pick(lang, copyData.eyebrow)} heading={pick(lang, copyData.heading)} lead={pick(lang, copyData.lead)} primary={{
    label: pick(lang, COMMON.requestQuote),
    to: "/RequestAQuotePage"
  }} secondary={{
    label: pick(lang, copyData.secondaryLabel),
    to: "/ContactPage"
  }} />;
}